// extracted by mini-css-extract-plugin
export var wrapper = "AudioCircle-module--wrapper--1d-6N";
export var circle = "AudioCircle-module--circle--1PAVK";
export var content = "AudioCircle-module--content--VOIPZ";
export var progress = "AudioCircle-module--progress--26LZO";
export var progressBar = "AudioCircle-module--progress-bar--2UajR";
export var progressBarDot = "AudioCircle-module--progress-bar-dot--Cbv7U";
export var text = "AudioCircle-module--text--2i9zK";
export var icon = "AudioCircle-module--icon--3M0uJ";